import { render, staticRenderFns } from "./FracField.vue?vue&type=template&id=2ead2a01&scoped=true&"
import script from "./FracField.vue?vue&type=script&lang=ts&"
export * from "./FracField.vue?vue&type=script&lang=ts&"
import style0 from "./FracField.vue?vue&type=style&index=0&id=2ead2a01&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ead2a01",
  null
  
)

export default component.exports